import { createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { z } from 'zod';

import { can } from '@simplificalo/contracts/permissions';
import { CaptacionPage } from '@/features/captacion/components/captacion-page';
import { useCurrentUserRole } from '@/lib/team';

const searchSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
});

export const Route = createFileRoute('/_app/captacion/')({
  component: CaptacionGuard,
  validateSearch: (raw) => searchSchema.parse(raw),
});

function CaptacionGuard() {
  const role = useCurrentUserRole();

  if (!can(role, 'metrics.financial.view')) {
    return (
      <div
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-lg border py-16 text-center"
        style={{ borderColor: 'var(--color-border)' }}
      >
        <Lock className="h-6 w-6" style={{ color: 'var(--color-fg-subtle)' }} aria-hidden />
        <h2 className="text-base font-semibold" style={{ color: 'var(--color-fg)' }}>
          Acceso restringido
        </h2>
        <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
          El panel de Captación requiere permiso de métricas financieras.
        </p>
      </div>
    );
  }

  return <CaptacionPage />;
}
